import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";
import { GET_ALL_HEAD_TYPE, GET_ALL_PACKAGE_TYPE, GET_ALL_PACKAGES, GET_PACKAGE_CODE_LIST } from "../../api/endpoints";
import openNotification from "../../components/Common/OpenNotification";

const initialState = {
    packages: [],
    packageTypes: [],
    headTypes: [],
    packageCodeList: [],
    loading: false,
    error: null,
    totalPagesPackages: 0,
};

export const fetchPackages = createAsyncThunk(
    "package/fetchPackages",
    async ({ page, pageSize, headType, packageCode, search } = {}, { rejectWithValue }) => {
        try {
                const params = {};
                if (page) params.page = page;
                if (pageSize) params.limit = pageSize;
                if (headType) params.HEAD_TYPE = headType; // Add headType to params if provided
                if (packageCode) params.PACKAGE_TYPE_CODE = packageCode;
                if (search) params.search = search; 

                const response = await axiosInstance.get(`${GET_ALL_PACKAGES}`, {
                        params,
                });

                return response.data;
        } catch (error) {
            openNotification(
                error?.response?.data?.message || "Something went wrong."
            );
            return rejectWithValue(
                error?.response?.data?.message || "Something went wrong."
            );
        }
    }
);

export const createPackageMaster = createAsyncThunk(
    "package/createPackageMaster",
    async (packageData, { rejectWithValue }) => {
        // Accept packageData as argument
        try {
            const response = await axiosInstance.post(
                GET_ALL_PACKAGES,
                packageData
            ); // Send packageData in request body
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error?.response || "Something went wrong."
            );
        }
    }
);

export const fetchPackageTypeMaster = createAsyncThunk(
    "package/fetchPackageTypeMaster",
    async (_, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(GET_ALL_PACKAGE_TYPE);
            return response.data;
        } catch (error) {
            openNotification(
                error?.response?.data?.message || "Something went wrong."
            );
            return rejectWithValue(
                error?.response?.data?.message || "Something went wrong."
            );
        }
    }
);

export const fetchHeadTypeMaster = createAsyncThunk(
    "package/fetchHeadTypeMaster",
    async (_, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(GET_ALL_HEAD_TYPE);
            return response.data;
        } catch (error) {
            openNotification(
                error?.response?.data?.message || "Something went wrong."
            );
            return rejectWithValue(
                error?.response?.data?.message || "Something went wrong."
            );
        }
    }
);

export const createPackageTypeMaster = createAsyncThunk(
    "package/createPackageTypeMaster",
    async (packageTypeData, { rejectWithValue }) => {
        // Accept packageTypeData as argument
        try {
            const response = await axiosInstance.post(
                GET_ALL_PACKAGE_TYPE,
                packageTypeData
            ); // Send packageTypeData in request body
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error?.response || "Something went wrong."
            );
        }
    }
);

export const fetchPackageCodeList = createAsyncThunk(
    "package/fetchPackageCodeList",
    async (_, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(GET_PACKAGE_CODE_LIST);
            return response.data;
        } catch (error) {
            openNotification(
                error?.response?.data?.message || "Something went wrong."
            );
            return rejectWithValue(
                error?.response?.data?.message || "Something went wrong."
            );
        }
    }
);


const packageSlice = createSlice({
    name: "package",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Reducer for fetchPackages
            .addCase(fetchPackages.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.packages = [];
            })
            .addCase(fetchPackages.fulfilled, (state, action) => {
                state.loading = false;
                state.packages = action.payload.data.data;
                state.totalPagesPackages = action?.payload?.data?.total;
            })
            .addCase(fetchPackages.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // Reducer for fetchPackageTypeMaster
            .addCase(fetchPackageTypeMaster.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchPackageTypeMaster.fulfilled, (state, action) => {
                state.loading = false;
                state.packageTypes = action.payload.data; // Added packageTypes in state
            })
            .addCase(fetchPackageTypeMaster.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            .addCase(fetchHeadTypeMaster.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchHeadTypeMaster.fulfilled, (state, action) => {
                state.loading = false;
                state.headTypes = action.payload.data;
            })
            .addCase(fetchHeadTypeMaster.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            .addCase(fetchPackageCodeList.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchPackageCodeList.fulfilled, (state, action) => {
                state.loading = false;
                state.packageCodeList = action.payload.data;
            })
            .addCase(fetchPackageCodeList.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default packageSlice.reducer;
